export default {
  createShuttleReservations: 'Servis Rezervasyonu Oluştur',
  routeGroup: 'Rota Grubu',
  route: 'Rota',
  riders: 'Personel(ler)',
  reserveFor: 'Rezervasyon Tipi',
  singleDay: 'Tek Gün',
  period: 'Dönem',
  date: 'Tarih',
  dates: 'Tarihler',
  selectEndDate: 'Bitiş tarihi seç',
  from: 'Başlangıç',
  until: 'Bitiş',
  selectGroup: 'Grup seçin',
  selectRoute: 'Rota seçin',
  selectRiders: 'Personel seçin',
  selectStop: 'Durak seçin',
  riderSelected: '1 personel seçildi',
  ridersSelected: '{0} personel seçildi',
  searchRiders: 'Personel ara',
  noResults: 'Sonuç bulunamadı',
  selectStopsForRiders: 'Personeller için durak seçin',
  stop: 'Durak',
  selectRouteFirst: 'Önce bir rota seçin',
  viewAll: 'Tümünü Gör ({0})',
  create: 'Oluştur',
  ok: 'Tamam',
  capacityMayVary:
    'Rota kapasitesi değişkenlik gösterebilir. Rezervasyonlar yalnızca boş koltuk bulunan günler için oluşturulur.',
  openEndedNote:
    'Bitiş tarihi seçilmediği için personeller, rotanın tüm çalışma günlerinde geçerli olacak şekilde rotanın kalıcı yolcusu olarak eklenir.',
  dateNotOperating: 'Rota seçilen tarihte çalışmıyor.',
  successTitle: 'Rezervasyonlar Başarıyla Oluşturuldu',
  successMessage: 'Seçilen personeller için rezervasyonlar başarıyla oluşturuldu.',
  successRegularTitle: 'Personeller Rotaya Eklendi',
  successRegularMessage: 'Seçilen personeller rotanın kalıcı yolcusu olarak eklendi.',
  addRiders: 'Personel Ekle',
  createReservation: 'Rezervasyon Oluştur',
  partialTitle: 'Rezervasyonlar Kısmen Oluşturuldu',
  partialMessage: 'Bazı rezervasyonlar oluşturulamadı:',
  riderFailed: 'Bu personel için rezervasyon oluşturulamadı.',
  // Why a rider failed, by the BE reason code (VSER-14667)
  riderNotFound: 'Personel bulunamadı.',
  stopNotOnRoute: 'Seçilen durak bu rotada değil.',
  campusNotOnRoute: 'Seçilen kampüse bu rota uğramıyor.',
  riderRejectedWithCode: 'Rezervasyon reddedildi (hata kodu {0}).',
  riderUnexpectedError: 'Beklenmeyen bir hata nedeniyle rezervasyon kaydedilemedi.',
  // Multi-campus route groups (VSER-14667)
  boardingCampus: 'Biniş kampüsü',
  dropOffCampus: 'İniş kampüsü',
  campus: 'Kampüs',
  automaticCampus: 'Otomatik',
  automaticCampusNote:
    'Bu rota grubu birden fazla kampüse hizmet veriyor. Otomatik seçildiğinde personel bu rotada kullandığı kampüste kalır; yoksa kendi kampüsü kullanılır.',
  campusPerRider: 'Personel bazında kampüs:',
  capacityFullOn: 'Şu günlerde boş koltuk yok: {0}',
  notOperatingOn:
    'Rota, seçilen bazı tarihlerde çalışmıyor ({0}). Rezervasyonlar yalnızca rotanın çalıştığı günler için oluşturuldu.',
  deleteReservationTitle: 'Rezervasyonu Sil',
  deleteReservationMessage:
    '{0} adlı personelin {1} rotasındaki {2} tarihli rezervasyonunu silmek istediğinizden emin misiniz?',
  multiDayReservationMessage:
    'Bu çok günlü bir rezervasyon. Yalnızca seçili günü mü yoksa bu rezervasyondaki tüm günleri mi silmek istiyorsunuz?',
  delete: 'Sil',
  deleteThisDayOnly: 'Yalnızca Bu Günü Sil',
  deleteAllDays: 'Tüm Günleri Sil',
  deletedTitle: 'Rezervasyon Silindi',
  deletedMessage: 'Seçilen gün için rezervasyon silindi.',
  deletedAllMessage: 'Personelin bu rotadaki tüm rezervasyonları silindi.',
  notFoundTitle: 'Rezervasyon Bulunamadı',
  notFoundMessage: 'Bu personelin silinecek bir rezervasyonu kalmamış. Liste yenilenecek.',
  // Rotanın düzenli (kalıcı) yolcuları (VSER-14309)
  removeRiderTitle: 'Yolcuyu Çıkar',
  regularRiderMessage: '{0}, {1} rotasının düzenli yolcusu. Yolcuyu {2} tarihli seferden çıkarmak istiyor musunuz?',
  optOutExplanation:
    'Yalnızca Bu Günü Sil, yolcuyu sadece bu seferden çıkarır. Opt-Out ise yolcuyu rotanın her iki yönünden ve rota grubundan tamamen çıkarır.',
  optOut: 'Opt-Out',
  regularDayCancelledTitle: 'Yolcu Seferden Çıkarıldı',
  regularDayCancelledMessage: 'Yolcu yalnızca bu seferden çıkarıldı. Bu rotadaki diğer seferleri etkilenmez.',
  optedOutTitle: 'Yolcu Rotadan Çıkarıldı',
  optedOutMessage: 'Yolcu bu rotanın her iki yönünden ve rota grubundan çıkarıldı.',
  // Dinamik rota grupları (VSER-14182)
  selectLocationsForRiders: 'Personeller için konum seçin',
  createRequest: 'Talep Oluştur',
  selectLocation: 'Konum Seç',
  selectAnotherLocation: 'Başka Konum Seç',
  preferredPickupSuffix: '(Tercih edilen biniş adresi)',
  selectLocationTitle: 'Dinamik Servis Talebi için Konum Seç',
  searchLocation: 'Konum ara',
  movePinIntoServiceArea: 'Pini, mavi ile vurgulanan hizmet bölgesinin içine taşıyın.',
  moveToServiceArea: 'Hizmet Bölgesine Git',
  noPreferredAddress: 'Tercih edilen biniş adresi bulunamadı',
  noPreferredAddressPlacePin:
    'Tercih edilen biniş adresi bulunamadı. Personelin biniş/iniş konumu olarak atamak istediğiniz yere haritada sağ tıklayın.',
  requestsSuccessTitle: 'Rezervasyon Talepleri Başarıyla Oluşturuldu',
  requestsSuccessMessage: 'Seçilen personeller için rezervasyon talepleri başarıyla oluşturuldu.',
  requestsPartialTitle: 'Talepler Kısmen Oluşturuldu',
  requestsPartialMessage: 'Bazı talepler oluşturulamadı:',
  riderWaitlisted: 'Bekleme listesine eklendi (sıra {0}).',
  riderQuotaExceeded: 'Seçilen dönem için rota grubu kotası dolu.',
  riderRequestFailed: 'Bu personel için talep oluşturulamadı.',
  alreadyRequestedOn: 'Şu günlerde zaten talebi vardı: {0}',
  groupBeingOptimized:
    'Bu grubun rotaları şu anda optimize ediliyor. Rotalar kesinleştiğinde rezervasyon işlemleri yapılabilir.',
  cancelReservationTooltip: 'Rezervasyonu sil',
  deletingReservation: 'Rezervasyon siliniyor…',
  boardingStatus: 'Biniş Durumu',
  cancellationTime: 'İptal Zamanı',
  boardingStatuses: {
    ARRIVED: 'Vardı',
    AWAITING: 'Bekliyor',
    BOARDED: 'Bindi',
    NO_SHOW: 'Gelmedi',
    SKIPPED: 'Atlandı',
  },
  errors: {
    routeNotFound: 'Rota bulunamadı.',
    invalidDay: 'Geçersiz tarih seçimi.',
    cancelFailed: 'Rezervasyon silinemedi.',
    stopAlreadyServed: 'Bu seferde yolcunun durağı geçildiği için yolcu seferden çıkarılamaz.',
  },
};
